import { ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/util/cn'
import Typography from '@/app/components/typography'
import { motion } from 'framer-motion'
import { Slide } from '@/app/(site)/(static)/about/sections/values/slides'

type Props = {
    children: ReactNode
    isActive?: boolean
    classNames?: Partial<Record<'base' | 'text', string>>
} & Omit<HTMLAttributes<HTMLButtonElement>, 'className'> &
    Pick<Slide, 'gradientClassName'>

const Button = forwardRef(
    ({ isActive, gradientClassName, children, classNames, ...rest }: Props, ref: ForwardedRef<HTMLButtonElement>) => (
        <button
            ref={ref}
            className={cn('group relative h-11 w-full cursor-pointer rounded-full', classNames?.base)}
            {...rest}
        >
            {isActive && (
                <motion.div
                    layoutId="underlay"
                    className={cn(
                        'absolute top-0 left-0 size-full rounded-full shadow-md transition-opacity group-hover:opacity-100',
                        gradientClassName
                    )}
                    transition={{
                        layout: {
                            type: 'spring',
                            stiffness: 300,
                            damping: 15,
                            mass: 0.3,
                        },
                    }}
                />
            )}

            <Typography
                variant="text-lg"
                fontFamily="nexaBlack"
                className={cn(
                    'relative font-medium drop-shadow',
                    !isActive && 'group-hover:opacity-75',
                    classNames?.text
                )}
            >
                {children}
            </Typography>
        </button>
    )
)

Button.displayName = 'Button'

export default Button
